import { Button, Row, Col, Typography, message, Space } from 'antd';
import { useFlowStore } from '../store';
import { useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { getAuthBaseUrl } from '../Config';

const { Title, Text } = Typography;

const providers = [
  { name: 'Google', logo: '/google.png' },
  { name: 'Facebook', logo: '/Facebook_Logo_%282019%29.png' },
  { name: 'Microsoft', logo: '/Microsoft_logo.svg' },
  { name: 'X', logo: 'X-Logo.png' },
  { name: 'Discord', logo: '/discord.png' },
];

const LoginPage = () => {
  const { clearError, error, isAuth } = useFlowStore();
  const navigate = useNavigate();

  // If user is already authenticated, redirect to topics page
  useEffect(() => {
    if (isAuth) {
      navigate('/topics');
    }
  }, [isAuth, navigate]);

  const handleLogin = (provider: string) => {
    const providerMap: Record<string, string> = {
      'Google': 'google',
      'Facebook': 'facebook',
      'Microsoft': 'microsoft',
      'X': 'twitter',
      'Discord': 'discord'
    };

    const providerName = providerMap[provider] || provider.toLowerCase();
    
    // Get the backend URL - this is crucial for SSO to work
    const backendUrl = getAuthBaseUrl();

    // Special case for Twitter which needs our custom implementation
    if (providerName === 'twitter') {
      window.location.href = `${backendUrl}/auth/twitter/login`;
      return;
    }

    // Create the full redirect URL to the backend
    // The backend will handle the authentication and return the user data
    const redirectUrl = `${backendUrl}/auth/${providerName}/login`;

    // Redirect to the auth endpoint on the backend
    window.location.href = redirectUrl;
  };

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
      if (error != null) errorDisplayer(error)
    }, [error])

  const errorDisplayer = (content: string | React.ReactNode) => {
    messageApi.open({
      type: 'error',
      content: content,
      duration: 2.5,
    })
    .then(() => clearError())
  };

  return (
    <div style={{ padding: '24px', maxWidth: '400px', margin: 'auto', textAlign: 'center' }}>
      {contextHolder}
      <Title level={2}>Log In</Title>
      <Row gutter={[16, 16]} justify="center">
        {providers.map((provider) => (
          <Col span={24} key={provider.name}>
            <Button
              block
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                padding: '30px',
                height: '50px',
              }}
              onClick={() => handleLogin(provider.name)}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <img
                  src={provider.logo}
                  alt={`${provider.name} logo`}
                  style={{
                    width: '50px',
                    height: '50px',
                    marginRight: '10px',
                  }}
                />
                <span style={{ textAlign: 'left', width: '100%' }}>Continue with {provider.name}</span>
              </div>
            </Button>
          </Col>
        ))}
      </Row>
      <Space direction="vertical" style={{ marginTop: '24px' }}>
        <Text type="secondary">
          By logging in, you agree to our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-of-service">Terms of Service</Link>
        </Text>
      </Space>
    </div>
  );
};

export default LoginPage;
